var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"bcx-transition-fade-scale"}},[(_vm.isOpened)?_c('RecommendUserForProjectsLayer',{staticClass:"bc-recommend-mobile-layer",on:{"close":_vm.onClose}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }